import { Box, BoxProps } from "@chakra-ui/react";

const SIZE = "30px";

interface CountdownDigitProps extends BoxProps {
  value: number;
  showColon?: boolean;
}

export const CountdownDigit = ({
  value,
  showColon,
  ...props
}: CountdownDigitProps) => {
  return (
    <>
      <Box
        backgroundColor={"white"}
        minW={SIZE}
        height={SIZE}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"5px"}
        fontWeight={"bold"}
        color={"gray.900"}
        {...props}
      >
        {value < 10 ? `0${value}` : value}
      </Box>
      {showColon ? (
        <Box fontWeight={"bold"} paddingLeft={1} paddingRight={1}>
          :
        </Box>
      ) : null}
    </>
  );
};
